function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M64.32,18.9l-.11-1.39c-.06-.77-.6-1.41-1.34-1.6-2.05-.52-4.17-.98-6.37-1.38-.92-.17-1.82.4-2.06,1.3l-.23.87c-.03.12.05.24.17.26,3.36.53,6.59,1.26,9.67,2.16.14.04.28-.07.27-.22Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M31.42,29.1c.24,1.05,1.17,1.79,2.25,1.79h12.66c1.08,0,2.01-.74,2.25-1.79l2.47-10.72c.05-.2-.09-.4-.29-.43-3.44-.46-7.04-.7-10.76-.7s-7.32.24-10.76.7c-.2.03-.34.22-.29.43l2.47,10.72Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M25.79,16.69l-.23-.87c-.24-.9-1.14-1.47-2.06-1.3-2.2.41-4.33.87-6.37,1.38-.74.19-1.28.83-1.34,1.6l-.11,1.39c-.01.15.13.26.27.22,3.08-.91,6.31-1.63,9.67-2.16.12-.02.2-.14.17-.26Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M75.96,46.2c-1.64-12.45-4.02-18.58-5.65-21.61-.82-1.52-2.18-2.67-3.81-3.23-3.75-1.28-7.87-2.3-12.26-3-.17-.03-.33.08-.36.25l-2.83,12.27c-.43,1.84-2.05,3.13-3.94,3.13h-14.2c-1.89,0-3.51-1.29-3.94-3.13l-2.83-12.27c-.04-.16-.2-.27-.36-.25-4.39.7-8.51,1.72-12.26,3-1.63.56-2.99,1.71-3.81,3.23-1.63,3.03-4.01,9.15-5.65,21.61-1.91,14.51,4.88,18.61,8.56,19.26,1.49.26,2.97-.56,3.53-1.97l4.89-13.06c.43-1.09,1.21-1.95,2.15-2.52,1.19,1.78,3.21,2.96,5.51,2.96,2.07,0,3.91-.95,5.12-2.43,1.89.19,3.89.3,6.19.3s4.35-.1,6.26-.3c1.21,1.49,3.06,2.44,5.13,2.44,2.28,0,4.3-1.16,5.49-2.92.92.56,1.67,1.42,2.1,2.48l4.89,13.06c.56,1.41,2.04,2.23,3.53,1.97,3.68-.65,10.46-4.75,8.56-19.26ZM14.79,35.38h-2.19c-.43,0-.77-.35-.77-.77v-1.61c0-.43.35-.77.77-.77h2.19l1.58,1.58-1.58,1.58ZM19.67,39.3c0,.43-.35.77-.77.77h-1.61c-.43,0-.77-.35-.77-.77v-2.19l1.58-1.58,1.58,1.58v2.19ZM19.67,30.49l-1.58,1.58-1.58-1.58v-2.19c0-.43.35-.77.77-.77h1.61c.43,0,.77.35.77.77v2.19ZM24.36,34.6c0,.43-.35.77-.77.77h-2.19l-1.58-1.58,1.58-1.58h2.19c.43,0,.77.35.77.77v1.61ZM28.69,48.07c-2.11,0-3.82-1.71-3.82-3.82s1.71-3.82,3.82-3.82,3.82,1.71,3.82,3.82-1.71,3.82-3.82,3.82ZM42.9,38.05c0,.45-.36.81-.81.81h-4.19c-.45,0-.81-.36-.81-.81h0c0-.45.36-.81.81-.81h4.19c.45,0,.81.36.81.81h0ZM51.39,48.07c-2.11,0-3.82-1.71-3.82-3.82s1.71-3.82,3.82-3.82,3.82,1.71,3.82,3.82-1.71,3.82-3.82,3.82ZM57.67,35.86c-1.12,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02ZM62.64,40.83c-1.12,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02ZM62.64,30.89c-1.12,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02ZM67.61,35.86c-1.12,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/ESports-active.82599f2f.svg";
export { SvgComponent as ReactComponent };